import type { Trend } from '../../../domain/company';
import { NoDataView, NoDataViewVariant } from '../NoDataView';

import { TrafficVisitsChart } from './TrafficVisitsChart';

export const TrafficVisitsContent = ({ trend }: { trend: Trend[] | undefined }) => {
  return trend && trend.length > 0 ? (
    <TrafficVisitsChart data={trend} />
  ) : (
    <NoDataView variant={NoDataViewVariant.monthlyVisits} />
  );
};
